module.exports = __webpack_public_path__ + "media/customize/icon-bottom-left-b2d460cb.svg";